import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(utc);
dayjs.extend(customParseFormat);

export const days= ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
export const dayStatuses = [
    "Work",
    "Holiday",
    "Weekend",
    "Sick",
    "Off",
    "TimeCompensation",
    "EmergencyService",
    "ChildSick",
    "PublicHoliday",
  ];
  
  export const getColorFromStatus = (status) => {
    // Medium pastel color palette - slightly darker for better visibility
    const colors = {
      Work: "#d9f7be",               // Light green – productive
      Holiday: "#efdbff",            // Light purple – personal time off
      Weekend: "#e8e8e8",            // Light gray – non-working days
      Sick: "#ffccc7",               // Light coral – health alert
      Off: "#d9d9d9",                // Silver gray – inactive
      TimeCompensation: "#b5f5ec",   // Light teal – compensation time
      EmergencyService: "#ffe7ba",   // Light orange – emergency/on-call
      ChildSick: "#ffd6e7",          // Light pink – child care
      PublicHoliday: "#bae7ff",      // Light blue – public holiday
      Vacation: "#fff1b8",           // Light yellow – vacation
    };

    return colors[status] || "#f0f0f0"; // fallback to light gray
  };

  // Get appropriate text color (white or black) based on status background
  export const getTextColorForStatus = (status) => {
    // Optimized dark text colors for medium pastel backgrounds
    // Using darker, more saturated colors for better contrast
    const textColors = {
      Work: "#135200",              // Very dark green on #d9f7be
      Holiday: "#22075e",           // Very dark purple on #efdbff
      Weekend: "#434343",           // Dark gray on #e8e8e8
      Sick: "#a8071a",              // Very dark red on #ffccc7
      Off: "#595959",               // Medium-dark gray on #d9d9d9
      TimeCompensation: "#00474f",  // Very dark teal on #b5f5ec
      EmergencyService: "#873800",  // Very dark orange on #ffe7ba
      ChildSick: "#9e1068",         // Very dark magenta on #ffd6e7
      PublicHoliday: "#003a8c",     // Very dark blue on #bae7ff
      Vacation: "#874d00",          // Very dark gold on #fff1b8
    };

    return textColors[status] || "#262626"; // fallback to dark gray
  };
  
  export const shiftColors = {
    early: "green",
    late: "blue",
    night: "purple",
    off: "default",
  };

export const mapIndexToStatus = (index) => dayStatuses[index] || "Work";
export const mapStatusToIndex = (status) => dayStatuses.indexOf(status);
export const getDateFromWeekAndDay=(year,week,day)=>{
  const daysMap = {
    Monday: 0,
    Tuesday: 1,
    Wednesday: 2,
    Thursday: 3,
    Friday: 4,
    Saturday: 5,
    Sunday: 6
  };
  const dayIndex = daysMap[day];
  if (dayIndex === undefined) throw new Error("Invalid weekday: " + day);

  // ISO weeks: Week 1 is the week with the first Thursday of the year
  const simple = new Date(year, 0, 4); // January 4th is always in week 1
  // For ISO weeks, Monday=1, Sunday=7 (not 0)
  const dayOfWeek = simple.getDay() || 7; // Treat Sunday (0) as 7
  const isoWeekStart = new Date(
    simple.setDate(simple.getDate() - dayOfWeek + 1) // Monday of that week
  );

  const result = new Date(isoWeekStart);
  result.setDate(isoWeekStart.getDate() + (week - 1) * 7 + dayIndex);
  return result;


}
export const getWeekNumber = (date) => {
  const firstDayOfYear = new Date(date.getFullYear(), 0, 1);
  const pastDaysOfYear = (date - firstDayOfYear) / 86400000;
  return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
};

